import { render, staticRenderFns } from "./PharmaceuticalCareButton.vue?vue&type=template&id=1d5bfe77&scoped=true&"
import script from "./PharmaceuticalCareButton.vue?vue&type=script&lang=js&"
export * from "./PharmaceuticalCareButton.vue?vue&type=script&lang=js&"
import style0 from "./PharmaceuticalCareButton.vue?vue&type=style&index=0&id=1d5bfe77&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5bfe77",
  null
  
)

export default component.exports